import React from "react"
import { Button, Col, OverlayTrigger, Tooltip } from "react-bootstrap"
import { useAuth } from "../../context/AuthContext"

const DocumentUploadCard = ({
  title,
  files,
  onPreview,
  onUpload,
  onDelete,
  isSubmitting,
  disabled,
  deleteDisabled,
  uploadTooltip,
  fileKindIds = [],
  className = ""
}) => {
  const { getAppLookupValue } = useAuth()
  const renderUploadButton = () => {
    const button = (
      <Button
        variant="outline-primary"
        size="sm"
        className="mt-auto w-100"
        onClick={() => onUpload(fileKindIds)}
        disabled={isSubmitting || disabled}>
        <i className="fas fa-upload me-2" />
        Ανέβασμα
      </Button>
    )

    if (disabled && uploadTooltip) {
      return (
        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${title}`}>{uploadTooltip}</Tooltip>}>
          <span className="mt-auto d-inline-block">{button}</span>
        </OverlayTrigger>
      )
    }

    return button
  }

  return (
    <Col className={`d-flex flex-column text-center mb-md-0 ${className}`} style={{ maxWidth: "20%" }}>
      {files?.length > 0 ? (
        <i className="fas fa-file-alt fa-3x text-primary mb-2" />
      ) : (
        <>
          <i className="fas fa-file-alt fa-3x text-muted mb-2" style={{ opacity: 0.5 }} />
        </>
      )}
      <h6
        className={`mb-3 ${(!files || files.length === 0) && "text-muted"}`}
        style={{ opacity: !files || files.length === 0 ? 0.5 : 1 }}>
        {title}
      </h6>

      {files?.length > 0 && (
        <div className="d-flex flex-column align-items-center">
          {files?.map((file, index) => (
            <div
              key={index}
              className={`d-flex flex-column w-100 ${index !== files.length - 1 && " border-bottom pb-1"} ${
                index === files.length - 1 && "mb-2"
              }`}>
              <div className="d-flex align-items-center justify-content-center">
                <small
                  className="d-block overflow-hidden me-2"
                  title={file.FileName}
                  onClick={() => onPreview(file)}
                  style={{ cursor: "pointer" }}>
                  {file.FileName}
                </small>
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => onDelete(file)}
                  disabled={isSubmitting || deleteDisabled}
                  title="Διαγραφή"
                  style={{ color: "#dc3545", padding: "0.25rem 0.5rem" }}>
                  <i className="fas fa-trash" />
                </Button>
              </div>
              <small className="text-muted" style={{ fontSize: "0.6rem", fontWeight: "bold" }}>
                {fileKindIds.length > 1 && getAppLookupValue("FilesKind", file.FileKindID)}
              </small>
            </div>
          ))}
        </div>
      )}
      {renderUploadButton()}
    </Col>
  )
}

export default DocumentUploadCard
